<template>
  <sa-page-layout :btnBackVisible="true" :linkback="'/magazzino/magazzini'" :btnNewVisible="false" :btnRefreshVisible="true" :showModalLoading="showModalLoading" @refresh="onSubmit()">
    <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
            <label class="sa-label-data">Codice Articolo</label>
            <b-form-input v-model="filtroGiacenzaMagazzino.codiceArticolo" type="search" placeholder="Codice Articolo"></b-form-input>
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
            <label class="sa-label-data">Tipologia Operazione</label>
            <b-form-select v-model="filtroGiacenzaMagazzino.causaleDocumentoOperazioneMagazzino" :options="operazioneMagazzinoOptions" text-field="text" value-field="value" placeholder="Seleziona Tipologia Operazione">
              <template #first>
                <b-form-select-option :value="null"> TUTTI </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row style="margin-top: 5px">
          <b-col class="sa-padding-right text-right mb-3">
            <b-button type="submit" variant="info">{{ this.$i18n.t("global.lblFind") }}</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <template slot="table-body"><magazzino-magazzini-view-component ref="cmpMagazzinoMagazziniViewComponent"></magazzino-magazzini-view-component> </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import MagazzinoMagazziniViewComponent from "../components/MagazzinoMagazziniViewComponent.vue";

export default {
  name: "MagazzinoMgazziniView",
  mixins: [],
  components: { SaPageLayout, MagazzinoMagazziniViewComponent },
  data() {
    return {
      id: null,
      showModalLoading: false,
      filtroGiacenzaMagazzino: {
        codiceArticolo: null,
        causaleDocumentoOperazioneMagazzino: null,
      },
      operazioneMagazzinoOptions: [
        { text: "CARICO", value: 1 },
        { text: "SCARICO", value: -1 },
      ],
    };
  },
  /* */
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
    me.filtroGiacenzaMagazzino.idMagazzino = me.id;
  },

  methods: {
    onSubmit() {
      let me = this;
      me.$refs.cmpMagazzinoMagazziniViewComponent.init(me.filtroGiacenzaMagazzino);
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onReset() {
      let me = this;
      me.filtroGiacenzaMagazzino = {
        codiceArticolo: null,
        causaleDocumentoOperazioneMagazzino: null,
        idMagazzino: me.id,
      };
      me.$refs.cmpMagazzinoMagazziniViewComponent.init(me.filtroGiacenzaMagazzino);
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
  },
};
</script>

<style></style>
